import { render, staticRenderFns } from "./ResourceReference.vue?vue&type=template&id=9035ecca"
import script from "./ResourceReference.vue?vue&type=script&lang=js"
export * from "./ResourceReference.vue?vue&type=script&lang=js"
import style0 from "./ResourceReference.vue?vue&type=style&index=0&id=9035ecca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports